import { useMemo } from 'react';
import gettext from '@sdk/lang/gettext';
import { SUBSCRIPTION_LEVELS } from '@sdk/account/constants';
import { SUBSCRIPTION_NAMES } from '@sdk/common/constants';
import { SubscriptionPlanNames } from '@sdk/account/types';

import {
  downgradeFeaturesToLose,
  cancelFeaturesToLoseFromBusiness,
  cancelFeaturesToLoseFromPremium,
} from '@web/account/billing/DowngradeSubscriptionModal/featuresToLose';

export function useFeaturesToLose(
  isDowngradeOnly: boolean,
  subscriptionLevel: number,
  isOldPremium: boolean
) {
  const features = useMemo(() => {
    if (isDowngradeOnly) {
      return downgradeFeaturesToLose;
    }

    return subscriptionLevel > SUBSCRIPTION_LEVELS.PREMIUM
      ? cancelFeaturesToLoseFromBusiness
      : cancelFeaturesToLoseFromPremium;
  }, [isDowngradeOnly, subscriptionLevel]);

  const primaryText = isDowngradeOnly
    ? gettext(
        'We are sorry to hear that the Business plan did not work for you. If you miss the benefits of it, you are always welcome to upgrade again.'
      )
    : gettext(
        'We are sorry to hear that the %(subscriptionName)s plan did not work for you. If you miss the benefits of it, you are always welcome to resume your subscription at any time.',
        {
          subscriptionName: isOldPremium
            ? SubscriptionPlanNames.premium
            : SUBSCRIPTION_NAMES[subscriptionLevel],
        }
      );

  const secondaryText = isDowngradeOnly
    ? gettext('Downgrading to Premium will make the following Business features unavailable:')
    : gettext('Cancelling your subscription will make the following features unavailable:');

  return { features, primaryText, secondaryText };
}
